import { useState } from "react";
import { ApiError } from "../api/client";
import { useAdminAuth } from "./AdminAuthContext";

/** Sign-in screen: the seeded admin email and password, checked by the server. */
export function AdminLogin() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("That email and password were not accepted.");
      } else {
        setError(err instanceof Error ? err.message : "Sign-in failed.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="admin-login">
      <h1>Admin sign-in</h1>
      <p className="muted" style={{ fontSize: "0.85rem" }}>
        Sign in with the seeded admin account — the{" "}
        <span className="mono">ADMIN_EMAIL</span> and{" "}
        <span className="mono">ADMIN_PASSWORD</span> configured for this site.
      </p>
      {error && (
        <p className="notice notice--err" role="alert">
          ✕ {error}
        </p>
      )}
      <form className="form" onSubmit={onSubmit} noValidate>
        <div className="field">
          <label htmlFor="adminemail">Email</label>
          <input
            id="adminemail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
          />
        </div>
        <div className="field">
          <label htmlFor="adminpassword">Password</label>
          <input
            id="adminpassword"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <div>
          <button
            className="btn"
            type="submit"
            disabled={busy || !email.trim() || !password}
          >
            {busy ? "Checking…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
